export const ClassUtil = {
	addClass: function(node, className){
		if(node){
			if (node.classList)
				node.classList.add(className);
			else{
				try{
                    node.className += ' ' + className;
				}
                catch(ex){
					node.setAttribute('class', `${node.getAttribute('class')} ${className}`);
				}
			}

		}
	},

	removeClass: function(node, className){
		if(node){
			if (node.classList)
				node.classList.remove(className);
			else {
				try{
					node.className = node.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
                catch(ex){
                    node.setAttribute('class', node.getAttribute('class').replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' '));
				}
            }
		}
	}
}